 <template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>

    <!-- Overlay proses: spinner + backdrop -->
    <v-overlay
      :value="loading.dialog"
      color="#0b3d2e"
      opacity="0.55"
      z-index="300"
      class="gw-spinner-overlay"
    >
      <div class="gw-spinner" role="status" aria-live="polite">
        <v-progress-circular
          indeterminate
          color="#8fd6b5"
          size="52"
          width="4"
        ></v-progress-circular>
        <div class="gw-spinner__text">
          {{ loading.text || "Memproses…" }}
        </div>
      </div>
    </v-overlay>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import HeaderComponentVue from "./components/HeaderComponent.vue";
import FooterComponentVue from "./components/FooterComponent.vue";

export default {
  name: "BaseFrontend",
  components: {
    HeaderComponentVue,
    FooterComponentVue,
  },
  data: () => ({}),
  mounted() {
    this.setPage({
      crud: true,
    }).then(() => {
      this.getAppInfo().then(() => {
        this.getAppInfo().then(() => {
          window.document.title = this.info.app_company;
        });
      });
    });
  },
  computed: {
    ...mapState(["device", "theme", "info", "snackbar", "loading"]),
  },
  methods: {
    ...mapActions(["setPage", "getAppInfo", "snackbarClose"]),
  },
  watch: {},
};
</script>

<style lang="sass">
@import "../../assets/css/wow.css"
</style>